export default __webpack_public_path__ + "img/homepage.section4.01.asset.a2fe1597.jpg";